import SeoGenerator from './SeoGenerator';

export default SeoGenerator;
